export default __webpack_public_path__ + "static/media/amatic.e226a1b2.svg";